"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns a string of the given length padded with spaces or a given pad character.
 *
 * @see {@link https://gitlab.fitness-plus.net/developers/utils#leftpadstring-length-pad_string}
 */
function leftPad(string, length, pad_string) {
    if (pad_string === void 0) { pad_string = null; }
    string = String(string);
    var i = -1;
    if (!pad_string && pad_string !== 0) {
        pad_string = ' ';
    }
    length = length - string.length;
    while (++i < length) {
        string = pad_string + string;
    }
    return string;
}
exports.default = leftPad;
